import React from 'react';
import { Typography, Grid, Box } from '@mui/material';
import { StyledButton } from '../../components/ui/input/StyledButton';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

const styles = {
  root: {
    minHeight: '100vh',
    width: '100vw',
    margin: '0',
    backgroundSize: 'cover',
    backgroundPosition: 'top',
    backgroundImage:  `url('${"/assets/student_app_landing.png"}')`,
  },
};

const Landing = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = async (event) => {
    navigate('/login');
  };

  return (
    <Box>
      <Grid
        container
        spacing={3}
        alignContent="center"
        alignItems="center"
        style={styles.root}
        direction="column"
      >
        <Grid item xs={12}>
          <Typography
            variant="h2"
            component="h2"
            style={{
              textAlign: 'center',
              color: 'white',
              textShadow: ' #500101 0px 0px 2px, #500101 0px 0px 2px',
              "--webkit-font-smoothing": "auto",
              "--moz-osx-font-smoothing": "auto",
              fontSmooth: "auto",
              backgroundColor: 'none',
              fontFamily: "'Nunito Sans',sans-serif!important",
              marginTop:'64px'
            }}
          >
            {t('pages.landing.welcomeTitle')}<br />
            {(document.htmlTitle && parse(document.htmlTitle)) || document.title}
          </Typography>
        </Grid>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          alignContent="center"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <StyledButton onClick={handleClick} size="large" tabIndex={1}>
              {t('pages.landing.startButton')}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Landing;
